
const degreesToRadians = Math.PI / 180


/* eslint-disable complexity */


const positionKeys = [
    "topLeft", "center", "topRight", "bottomLeft", "bottomRight",
    "left", "right", "bottom", "top",
    "centerLeft", "centerRight", "bottomCenter", "topCenter"
]


function containsPositionParam (params) {
    if (params._positionKey) {
        return params._positionKey !== "none" && params._positionKey
    } else {
        return positionKeys.find(key => key in params)
    }
}


function copyPositionParam (params, target, {replace} = {}) {
    const key = containsPositionParam(params)
    if (key) {
        const {x, y} = getCoords(params[key])
        if (key in target && !replace) {
            target[key].x = x
            target[key].y = y
        } else {
            target[key] = {x, y}
        }
        return true
    }
    return false
}


function getTopLeftPoint (params, width, height) {
    let {_positionKey} = params
    if (_positionKey && _positionKey !== "topLeft") {
        return getTopLeftPointFromOtherCoord(_positionKey, params, width, height)
    }

    if (params.topLeft) { //should always be the first tested
        const {x, y} = getCoords(params.topLeft)
        return {x, y}
    }

    if (typeof width === "function") {
        width = width()
    }

    if (typeof height === "function") {
        height = height()
    }

    if (params.center) {
        const {x, y} = getCoords(params.center)
        return {
            x: x - width  / 2,
            y: y + height / 2
        }
    } else if (params.topRight) {
        const {x, y} = getCoords(params.topRight)
        return {
            x: x - width,
            y
        }
    } else if (params.bottomLeft) {
        const {x, y} = getCoords(params.bottomLeft)
        return {
            x,
            y: y + height
        }
    } else if (params.bottomRight) {
        const {x, y} = getCoords(params.bottomRight)
        return {
            x: x - width,
            y: y + height
        }
    } else if (params.centerLeft) {
        const {x, y} = getCoords(params.centerLeft)
        return {
            x,
            y: y + height / 2
        }
    } else if (params.centerRight) {
        const {x, y} = getCoords(params.centerRight)
        return {
            x: x - width,
            y: y + height / 2
        }
    } else if (params.bottomCenter) {
        const {x, y} = getCoords(params.bottomCenter)
        return {
            x: x - width / 2,
            y: y + height
        }
    } else if (params.topCenter) {  //should always be the last tested
        const {x, y} = getCoords(params.topCenter)
        return {
            x: x - width / 2,
            y
        }
    } else if (params.left) {
        const {x, y} = getCoords(params.left)
        return {
            x,
            y: y + height / 2
        }
    } else if (params.right) {
        const {x, y} = getCoords(params.right)
        return {
            x: x - width,
            y: y + height / 2
        }
    } else if (params.bottom) {
        const {x, y} = getCoords(params.bottom)
        return {
            x: x - width / 2,
            y: y + height
        }
    } else if (params.top) {
        const {x, y} = getCoords(params.top)
        return {
            x: x - width / 2,
            y
        }
    }
    return null
}


function getCenterPoint (params, width, height) {

    let {_positionKey} = params
    if (_positionKey && _positionKey !== "center") {
        return getCenterPointFromOtherCoord(_positionKey, params, width, height)
    }

    if (params.center) {
        const {x, y} = getCoords(params.center)
        return {x, y}
    }

    if (typeof width === "function") {
        width = width()
    }

    if (typeof height === "function") {
        height = height()
    }

    if (params.topLeft) {
        const {x, y} = getCoords(params.topLeft)
        return {
            x: x + width  / 2,
            y: y - height / 2
        }
    } else if (params.topRight) {
        const {x, y} = getCoords(params.topRight)
        return {
            x: x - width  / 2,
            y: y - height / 2
        }
    } else if (params.bottomLeft) {
        const {x, y} = getCoords(params.bottomLeft)
        return {
            x: x + width  / 2,
            y: y + height / 2
        }
    } else if (params.bottomRight) {
        const {x, y} = getCoords(params.bottomRight)
        return {
            x: x - width  / 2,
            y: y + height / 2
        }
    } else if (params.centerLeft) {
        const {x, y} = getCoords(params.centerLeft)
        return {
            x: x + width / 2,
            y
        }
    } else if (params.centerRight) {
        const {x, y} = getCoords(params.centerRight)
        return {
            x: x - width / 2,
            y
        }
    } else if (params.bottomCenter) {
        const {x, y} = getCoords(params.bottomCenter)
        return {
            x,
            y: y + height / 2
        }
    } else if (params.topCenter) {
        const {x, y} = getCoords(params.topCenter)
        return {
            x,
            y: y - height / 2
        }
    } else if (params.left) {
        const {x, y} = getCoords(params.left)
        return {
            x: x + width / 2,
            y
        }
    } else if (params.right) {
        const {x, y} = getCoords(params.right)
        return {
            x: x - width / 2,
            y
        }
    } else if (params.bottom) {
        const {x, y} = getCoords(params.bottom)
        return {
            x,
            y: y + height / 2
        }
    } else if (params.top) {
        const {x, y} = getCoords(params.top)
        return {
            x,
            y: y - height / 2
        }
    }
    return null
}



function getPivot (params, width, height) {
    if (params.pivot) {
        return getCoords(params.pivot)
    }
    if (params.topLeft) {
        return false
    } else if (params.topRight) {
        return {
            x: width,
            y: 0
        }
    } else if (params.bottomLeft) {
        return {
            x: 0,
            y: -height
        }
    } else if (params.bottomRight) {
        return {
            x: width,
            y: -height
        }
    } else if (params.center) {
        return {
            x: width  / 2,
            y: -height / 2
        }
    } else if (params.centerLeft || params.left) {
        return {
            x: 0,
            y: -height / 2
        }
    } else if (params.centerRight || params.right) {
        return {
            x: width,
            y: -height / 2
        }
    } else if (params.bottomCenter || params.bottom) {
        return {
            x: width / 2,
            y: -height
        }
    } else if (params.topCenter || params.top) {
        return {
            x: width / 2,
            y: 0
        }
    }
    return false
}



function getPivotRelativeToCenter (params, width, height) {
    let {pivot} = params

    if (pivot) {
        if (typeof pivot === "function") {
            pivot = pivot()
        }
        const {x, y} = pivot
        return {
            x: x - width  / 2,
            y: y + height / 2
        }
    }
    if (params.center) {
        return false
    } else if (params.topLeft) {
        return {
            x: -width / 2,
            y: height / 2
        }
    } else if (params.topRight) {
        return {
            x: width / 2,
            y: height / 2
        }
    } else if (params.bottomLeft) {
        return {
            x: -width / 2,
            y: -height / 2
        }
    } else if (params.bottomRight) {
        return {
            x: width / 2,
            y: -height / 2
        }
    } else if (params.centerLeft || params.left) {
        return {
            x: -width / 2,
            y: 0
        }
    } else if (params.centerRight || params.right) {
        return {
            x: width / 2,
            y: 0
        }
    } else if (params.bottomCenter || params.bottom) {
        return {
            x: 0,
            y: -height / 2
        }
    } else if (params.topCenter || params.top) {
        return {
            x: 0,
            y: height / 2
        }
    }
    return false
}




const topLeftToOtherPosition = {
    topLeft: ({x, y}) => {
        return {x, y}
    },
    top: ({x, y, width}) => {
        return {
            x: x + width / 2,
            y
        }
    },
    topRight: ({x, y, width}) => {
        return {
            x: x + width,
            y
        }
    },
    left: ({x, y, height}) => {
        return {
            x,
            y: y - height / 2
        }
    },
    center: ({x, y, width, height}) => {
        return {
            x: x + width  / 2,
            y: y - height / 2
        }
    },
    right: ({x, y, width, height}) => {
        return {
            x: x + width,
            y: y - height / 2
        }
    },
    bottomLeft: ({x, y, height}) => {
        return {
            x,
            y: y - height
        }
    },
    bottom: ({x, y, width, height}) => {
        return {
            x: x + width / 2,
            y: y - height
        }
    },
    bottomRight: ({x, y, width, height}) => {
        return {
            x: x + width,
            y: y - height
        }
    }
}


topLeftToOtherPosition.centerRight  = topLeftToOtherPosition.right
topLeftToOtherPosition.centerLeft   = topLeftToOtherPosition.left
topLeftToOtherPosition.bottomCenter = topLeftToOtherPosition.bottom
topLeftToOtherPosition.topCenter    = topLeftToOtherPosition.top



function getCoordsFor (positionName, params) {
    let {width, height} = params
    if (typeof width === "function") {
        width = width()
    }
    if (typeof height === "function") {
        height = height()
    }
    const {x, y} = getTopLeftPoint(params, width, height)
    return topLeftToOtherPosition[positionName]({x, y, width, height})
}


function getTopLeftPointFromOtherCoord (positionName, params, width, height) {
    if (positionName === "none") {
        return null
    }
    if (typeof width === "function") {
        width = width()
    }
    if (typeof height === "function") {
        height = height()
    }
    const {x, y} = getCoords(params[positionName])
    return topLeftToOtherPosition[positionName]({x, y, width: -width, height: -height})
}


function getCenterPointFromOtherCoord (positionName, params, width, height) {
    if (positionName === "none") {
        return null
    }
    if (typeof width === "function") {
        width = width()
    }
    if (typeof height === "function") {
        height = height()
    }
    const {x, y} = getCoords(params[positionName])
    const topLeft = topLeftToOtherPosition[positionName]({x, y, width: -width, height: -height})
    return {
        x: topLeft.x + width  / 2,
        y: topLeft.y - height / 2
    }
}



//FIXME optimize

function addPositionAccessor (object, positionName, {whenChanged} = {}) {

    if (positionName in object) {
        if (whenChanged) {
            let rawValue = dynamicCoords(object[positionName])
            Object.defineProperty(object, positionName, {
                get: () => rawValue,
                set: (value) => {
                    rawValue = dynamicCoords(value)
                    whenChanged({positionName, value: rawValue})
                },
                enumerable: true
            })
        }

        return
    }

    function dynamicCoords (coords) {

        if (!whenChanged) {
            return coords
        }
        let {x, y} = coords
        const result = {}

        Object.defineProperty(result, "x", {
            get: () => x,
            set: (value) => {
                if (x !== value) {
                    x = value
                    let {_positionKey} = object
                    if (positionName === _positionKey) {
                        whenChanged({positionName, value: result})
                    } else {
                        object[positionName] = {x, y}
                    }
                }
            },
            enumerable: true
        })

        Object.defineProperty(result, "y", {
            get: () => y,
            set: (value) => {
                if (y !== value) {
                    y = value
                    let {_positionKey} = object
                    if (positionName === _positionKey) {
                        whenChanged({positionName, value: result})
                    } else {
                        object[positionName] = {x, y}
                    }
                }
            },
            enumerable: true
        })

        return result
    }



    let getter

    if (positionName === "topLeft") {
        getter = () => {
            const {width, height} = object
            return dynamicCoords(getTopLeftPoint(object, width, height))
        }
    } else if (positionName === "center") {
        getter = () => {
            const {width, height} = object
            return dynamicCoords(getCenterPoint(object, width, height))
        }
    } else if (positionName === "none") {
        console.warn("No positionName found")
        return
    } else {
        let method = topLeftToOtherPosition[positionName]
        getter = () => {
            const {width, height} = object
            const {x, y} = getTopLeftPoint(object, width, height)
            return dynamicCoords(method({x, y, width, height}))
        }
    }


    Object.defineProperty(object, positionName, {
        get: getter,
        set: (value) => {
            let {_positionKey} = object

            delete object[positionName]
            object[positionName] = value

            if (_positionKey) {
                delete object[_positionKey]
                addPositionAccessor(object, _positionKey)
                if (whenChanged) {
                    addPositionAccessor(object, positionName, {whenChanged})
                }
            }

            object._positionKey = positionName

            if (whenChanged) {
                whenChanged({positionName, value: object[positionName]})
            }
        },
        enumerable:   true,
        configurable: true
    })

}




function addPositionAccessors (object, {whenChanged} = {}) {
    let truePositionKey = containsPositionParam(object)
    if (!truePositionKey) {
        truePositionKey = "none"
    }
    object._positionKey = truePositionKey
    positionKeys.forEach(positionName => addPositionAccessor(object, positionName, {whenChanged}))
}



/* eslint-enable complexity */


// pivot coords are relative to topLeftPoint
function topLeftPointWithPivot (topLeftPoint, orientation, pivot) {
    if (typeof topLeftPoint === "function") {
        topLeftPoint = topLeftPoint()
    }
    if (typeof orientation === "function") {
        orientation = orientation()
    }
    if (typeof pivot === "function") {
        pivot = pivot()
    }
    return topLeftPointWithPivotRaw(topLeftPoint, orientation, pivot)
}

function topLeftPointWithPivotRaw (topLeftPoint, orientation, pivot) {
    let rotatedPivot = rotateVector(pivot, orientation)
    return {
        x: topLeftPoint.x + pivot.x - rotatedPivot.x,
        y: topLeftPoint.y + pivot.y - rotatedPivot.y
    }
}


function getCenterPointAfterPivot (params) {
    let {width, height, orientation} = params
    let centerCoords = getCenterPoint(params, width, height)
    if (typeof orientation === "function") {
        orientation = orientation()
    }
    if (orientation) {
        let pivot = getPivotRelativeToCenter(params, width, height)
        if (pivot) {
            let rotatedPivot = rotateVector(pivot, orientation)
            return {
                x: centerCoords.x + pivot.x - rotatedPivot.x,
                y: centerCoords.y + pivot.y - rotatedPivot.y
            }
        }
    }
    return centerCoords
}


function pointsForRectangle (params, yDir = 1) {

    let {topLeftPoint, width, height, orientation} = normalizedParamsForRectangle(params, yDir)

    const {x, y} = topLeftPoint

    if (orientation) {

        const {x: ax, y: ay} = rotateVector({x: width, y: 0}, orientation)

        const {x: bx, y: by} = rotateVector({x: 0,     y: -yDir * height}, orientation)

        return [
            {x, y},
            {x: x + ax,      y: y + ay},
            {x: x + ax + bx, y: y + ay + by},
            {x: x + bx,      y: y + by}
        ]

    } else {

        const y2 = y - yDir * height
        return [
            {x, y},
            {x: x + width, y},
            {x: x + width, y: y2},
            {x,            y: y2}
        ]
    }

}


function normalizedParamsForRectangle (params, yDir = 1) { //eslint-disable-line complexity
    let {width, height, orientation = 0} = params

    if (width === undefined) {
        throw new Error('"width" param is missing')
    }

    if (height === undefined) {
        throw new Error('"height" param is missing')
    }

    if (typeof width === "function") {
        width = width()
    }

    if (typeof height === "function") {
        height = height()
    }

    if (typeof orientation === "function") {
        orientation = orientation()
    }

    let topLeftPoint = getTopLeftPoint(params, width, height * yDir)

    if (!topLeftPoint) {
        throw new Error('a position param is missing. Include one, for example "center", "topLeft"...')
    }

    if (orientation) {
        const pivot = getPivot(params, width, height)
        if (pivot) {
            topLeftPoint = topLeftPointWithPivotRaw(topLeftPoint, orientation, pivot)
        }
    }

    return {topLeftPoint, width, height, orientation}

}


function rotateVector ({x, y}, angleDeg) {
    let angleRad = angleDeg * degreesToRadians
    let cosAngle = Math.cos(angleRad)
    let sinAngle = Math.sin(angleRad)
    return {
        x: x * cosAngle - y * sinAngle,
        y: x * sinAngle + y * cosAngle
    }
}


function getCoords (value) {
    if (typeof value === "function") {
        return value()
    } else {
        return value
    }
}




export default {
    getTopLeftPoint,
    getCenterPoint,
    getCenterPointAfterPivot,
    getPivot,
    getPivotRelativeToCenter,
    topLeftPointWithPivot,
    containsPositionParam,
    copyPositionParam,
    getCoordsFor,
    rotateVector,
    addPositionAccessors,
    normalizedParamsForRectangle,
    pointsForRectangle,
    positionKeys
}
